// src/pages/Home.js
import React from 'react';
import ResetPassword from '../Authentication/ResetPassword.js'; 
function Home() {
  return (
    <div>
        <ResetPassword/>
    </div>
  );
}

export default Home;